import React, { useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { loginUser } from '../service/apiService';
import './LoginPage.css';

function LoginPage({ setUser }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await loginUser(username, password);
      if (res.status === 'success') {
        localStorage.setItem('user', JSON.stringify(res.user));
        setUser(res.user);
      } else {
        setError(res.message || 'Invalid credentials');
      }
    } catch (err) {
      setError('Server error, please try again later');
    }
  };

  return (
    <div className="login-page d-flex justify-content-center align-items-center vh-100">
      <Card className="login-card p-4 shadow-lg glass-card">
        <h3 className="text-center mb-3 text-dark fw-bold">Welcome Back</h3>
        {error && <p className="text-danger text-center">{error}</p>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </Form.Group>
          <Button type="submit" className="w-100 mt-2">Login</Button>
        </Form>
      </Card>
    </div>
  );
}

export default LoginPage;
